import { z } from 'zod'
import { isValidArray, isValidString } from '../school-form.utils'
import {
  RequiredStringSchema,
  YesOrNoSchema,
} from './application-shared.schema'
import { REQUIRED_BASIC_MESSAGE } from '../constants/constants'

export const StandardizedTestsSchema = z
  .object({
    standardizedTests: z.array(z.any()).optional(),
    isDoingStandardizedTests: YesOrNoSchema,
    howAreStudentsAssessed: RequiredStringSchema.optional(),
  })
  .superRefine((data, ctx) => {
    const {
      isDoingStandardizedTests,
      standardizedTests,
      howAreStudentsAssessed,
    } = data

    if (
      isDoingStandardizedTests === 'Yes' &&
      !isValidArray(standardizedTests)
    ) {
      ctx.addIssue({
        path: ['standardizedTests'],
        code: z.ZodIssueCode.custom,
        message: REQUIRED_BASIC_MESSAGE,
      })
    }

    if (
      isDoingStandardizedTests === 'No' &&
      !isValidString(howAreStudentsAssessed)
    ) {
      ctx.addIssue({
        path: ['howAreStudentsAssessed'],
        code: z.ZodIssueCode.custom,
        message: REQUIRED_BASIC_MESSAGE,
      })
    }
  })
